import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
export default {
  name: 'RecycleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return _createVNode("svg", _mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-recycle",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [_createTextVNode("   "), _createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M12 17l-2 2l2 2"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M10 19h9a2 2 0 0 0 1.75 -2.75l-.55 -1"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M8.536 11l-.732 -2.732l-2.732 .732"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M7.804 8.268l-4.5 7.794a2 2 0 0 0 1.506 2.89l1.141 .024"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M15.464 11l2.732 .732l.732 -2.732"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M18.196 11.732l-4.5 -7.794a2 2 0 0 0 -3.256 -.14l-.591 .976"
    }, null), _createTextVNode(" ")]);
  }
};